import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { Router } from '@angular/router';
import { MessageService } from './common/message.service';
import { LOGON_INFO } from './app.constants';


@Injectable()
export class AppInterceptor implements HttpInterceptor {

    constructor(
        private router: Router,
        public messageService: MessageService
    ) {  }

    //request, responseの変換を行う
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        let _headers: HttpHeaders = undefined;

        //http request headerにtokenを設定
        //File関連のrequest時にContent-Type指定するとエラーになるので、付けない
        if (request.url.indexOf("car-regist") > 0 || request.url.indexOf("car-update") > 0
                || request.url.indexOf("file-upload") > 0 || request.url.indexOf("file-download") > 0
                || request.url.indexOf("car-state") > 0) {
            _headers = request.headers.set('Authorization', 'JWT ' + LOGON_INFO.TOKEN);
        } else {
            _headers = request.headers.set('Authorization', 'JWT ' + LOGON_INFO.TOKEN).append('Content-Type', 'application/json');
        }

        const req_clon = request.clone({ headers: _headers });

        return next.handle(req_clon).catch(res => {

            if (res.status == 401) {
                alert("ログイン時間が経過しました。");
                this.router.navigate(['/login']);
            }
            else if (res.status == 403) {
                alert("サーバから切断されました。");
                this.router.navigate(['/login']);
            }
            else {
                console.log(res);
                this.messageService.clearAll();

                if (res.error) {
                    var errMsg = "処理中にエラーが発生しました。";
                    if (res.error.errors) {
                        errMsg = errMsg + "（";
                        res.error.errors.forEach(error => {
                            errMsg = errMsg + error;
                        });
                        errMsg = errMsg + "）";
                    }
                    else if (res.error.detail) {
                        //this.messageService.add(res.error.detail);
                        errMsg = res.error.detail;
                    }
                    else {
                        errMsg = errMsg + "（システム管理者に問い合わせください）";
                    }

                    this.messageService.addError(errMsg);
                }

                return Observable.throw(res);
            }
        });

    }

}



// WEBPACK FOOTER //
// ./src/app/app.interceptor.ts